import {sanitize} from "@/lib/utils";
import {HTMLAttributes} from "react";

export const DynamicHtmlElement = ({
  html,
  ...props
} : {
  html: string;
} & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div {...props} dangerouslySetInnerHTML={{__html: sanitize(html)}}></div>
  )
}
